import 'vuetify/styles'
import {createVuetify} from 'vuetify'
import DateFnsAdapter from '@date-io/date-fns'
import {enUS} from 'date-fns/locale/en-US'

export default createVuetify({
  defaults: {
    // V4 menus default to scroll-strategy "reposition", which keeps an open
    // dropdown pinned to the viewport (detached from its field) as the page
    // scrolls. Close them on scroll instead. Selects render an internal VMenu,
    // so this also covers v-select/v-autocomplete/v-combobox dropdowns.
    // V4's default enter transition (VDialogTransition) sets pointer-events:none
    // on the overlay content until the ~300-400ms scale-in finishes, so a click
    // during that window passes through the visible menu to whatever is beneath
    // it — for topbar menus that is the full-viewport navbar dimmer, whose click
    // handler closes them (module dropdown / option search lost the click and
    // shut instead of acting). A CSS transition never touches pointer-events.
    VMenu: {
      scrollStrategy: 'close',
      transition: 'fade-transition',
    },
    // color: focused label + underline render primary (V2 baseline); V4's
    // default leaves them at the plain text color.
    VSelect: {
      variant: 'underlined',
      hideDetails: 'auto',
      color: 'primary',
      autocomplete: 'off',
      // Passed explicitly to the inner VMenu, so the VMenu default above does
      // not reach it — see the pointer-events note there.
      transition: 'fade-transition',
    },
    VAutocomplete: {
      variant: 'underlined',
      hideDetails: 'auto',
      color: 'primary',
      autocomplete: 'off',
    },
    VCombobox: {
      variant: 'underlined',
      hideDetails: 'auto',
      color: 'primary',
      autocomplete: 'off',
    },
    VTextField: {
      variant: 'underlined',
      hideDetails: 'auto',
      color: 'primary',
      autocomplete: 'off',
    },
    VTextarea: {
      variant: 'underlined',
      hideDetails: 'auto',
      color: 'primary',
      autocomplete: 'off',
    },
    // Same pointer-events window as the menus, over the dialog's own scrim: a
    // click within ~300ms of opening closed the dialog instead of hitting its
    // content.
    VDialog: {
      transition: 'fade-transition',
    },
    VDatePicker: {
      hideHeader: true,
    },
    VBtnToggle: {
      variant: 'outlined',
      // 28px button height is the app-wide standard for segmented toggles.
      height: 28,
      VBtn: {
        // V4 v-btn-toggle children inherit 14px from VBtn defaults; V2 baseline
        // rendered toggle buttons at 12px / weight 500.
        style: 'font-size: 12px; font-weight: 500; height: 28px;',
      },
    },
    VTab: {
      // 'tab-header' marks this element as the h3 sub-header role's tab member.
      // Tab text color comes from `.v-application .v-tab` in
      // vuetify-overrides.scss; size+weight come from VBtn defaults (14/500).
      // px-8: the standard tab variant's inner padding.
      class: 'text-uppercase tab-header px-8',
    },
    // Standard tab variant app-wide: tabs share the row (grow) but cap at
    // 250px (rule in vuetify-overrides.scss), with overflow arrows when tight.
    VTabs: {
      color: 'primary',
      sliderColor: 'primary',
      grow: true,
      showArrows: true,
    },
    VIcon: {
      size: 20,
    },
    VCheckbox: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
    },
    VCheckboxBtn: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
    },
    VSwitch: {
      color: 'primary',
      density: 'compact',
      hideDetails: 'auto',
    },
    VSlider: {
      color: 'primary',
      hideDetails: 'auto',
      thumbSize: 20,
    },
    VRangeSlider: {
      color: 'primary',
      hideDetails: 'auto',
      thumbSize: 20,
    },
    VBtn: {
      style: 'font-size: 14px; font-weight: 500;',
    },
    VChip: {
      label: true,
      size: 'small',
      variant: 'outlined',
    },
  },
  date: {
    adapter: DateFnsAdapter,
    locale: {
      en: enUS,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#007AFF',
          secondary: '#b0bec5',
          accent: '#8c9eff',
          error: '#FF5721',
          success: '#4CAF50',
          warning: '#FB8C00',
          info: '#2196F3',
        }
      }
    }
  }
})
